/* eslint-disable @typescript-eslint/consistent-type-assertions -- RNW supports rem values, but RN's style types require numbers. */

const DEFAULT_ROOT_FONT_SIZE = 16;

export function normalizeAvatarSize(size: number): number {
  return `${size / DEFAULT_ROOT_FONT_SIZE}rem` as unknown as number;
}
